// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { QueryClient } from '@tanstack/react-query';

export const DEFAULT_POLL_INTERVAL = 2500;

const queryClient = (pollingEnabled?: boolean) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnReconnect: pollingEnabled,
        refetchOnWindowFocus: false,
        refetchInterval: pollingEnabled ? DEFAULT_POLL_INTERVAL : false,
        // to avoid flickering loading when the key changes because of the offset
        keepPreviousData: true,
      },
      mutations: {
        retry: 1,
      },
    },
  });

export default queryClient;
